const getScheduleHostListResponse = (response) => {
  const result =
    response?.users?.map((user) => ({
      value: user?.id,
      label: user?.name,
      isDisabled: !user?.isHostAvailable,
    })) ?? [];
  return result;
};

export default getScheduleHostListResponse;
